// Company registration slice

import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../store/store";

export interface ICompanyRegistrationBasicInfo {
  companyName: string;
  websiteUrl: string;
  YearsInOperation: string;
  vision: string; // A vision statement defines an organization’s long-term aspirations and desired future state, providing inspiration and guidance for strategic decision-making and goal-setting
  mission: string; // A mission statement is a short statement of why an organization exists, what its overall goal is, the goal of its operations
  aboutTheCompany: string;
  aiGeneratedInsight?: AIGeneratedCompanyInsight;
  businessSize?:string;
  businessType?:string;
  mainServices?:string;
  mainCustomer?:string;
  customerTypeDetails?:string;// Detailed description about customer
  revenueGenService?:string;
  usageOfTecInBusiness?:string;
  challenges?:string;
  businessChallengeDescription?:string;
}

const initialState: ICompanyRegistrationBasicInfo = {
  companyName: "",
  websiteUrl: "",
  YearsInOperation: "",
  vision: "",
  mission: "",
  aboutTheCompany: "",
  aiGeneratedInsight: undefined
};

export interface AIGeneratedCompanyInsight{
    Insights:Insight[];
}

export interface Insight {
  Question?: string;
  Title?: string;
  Details?: string;
  Answer?: string;
  QuestionType?: string[];
}

export enum WebScrapDataType{
  String,
  Array,
  Number
}

export interface IWebScrapData<T>{
  key: string;
  value: T;
  type: WebScrapDataType;
}

export const companyRegistrationSlice = createSlice({
  name: "companyRegistration",
  initialState,
  reducers: {
    registerCompanyInfo: (
      state,
      action: PayloadAction<ICompanyRegistrationBasicInfo>
    ) => {
      return { ...state, ...action.payload };
    },
    updateAIGeneratedCompanyInsight: (
      state,
      action: PayloadAction<ICompanyRegistrationBasicInfo>
    ) => {
      return { ...state, ...action.payload };
    },
  },
});

export const { registerCompanyInfo, updateAIGeneratedCompanyInsight } = companyRegistrationSlice.actions;
export const companyRegistrationSelector = (state: RootState) =>
  state.companyRegistrationReducer;
export default companyRegistrationSlice.reducer;
